import React from 'react';
import { View } from 'react-native';
import { Feather } from '@expo/vector-icons';

import Text from '../../../components/text/Text';
import { Card } from '../../../design/components';
import { useTheme } from '../../../theme';
import { useThemedStyles } from '../../../hooks/useThemedStyles';

const TONE_ICON = {
	success: 'check-circle',
	warning: 'alert-triangle',
	default: 'info',
};

/**
 * One-line state note on an End of day step screen: done ("Money bags
 * returned."), locked in training, or "Something missing? Tell your manager".
 * Props: text, tone ('success' | 'warning' | 'default')
 */
const StepNote = ({ text, tone = 'default' }) => {
	const styles = useThemedStyles(createStyles);
	const { theme: { ui: { colors } } } = useTheme();
	const color = tone === 'success' ? colors.success : tone === 'warning' ? colors.warning : colors.accent;

	return (
		<Card tone={tone} style={styles.card}>
			<Feather name={TONE_ICON[tone] || TONE_ICON.default} size={20} color={color} />
			<View style={styles.body}>
				<Text style={[styles.text, tone === 'warning' && styles.textWarning]}>{text}</Text>
			</View>
		</Card>
	);
};

const createStyles = ({ ui: { colors, radius, space, type } }) => ({
	card: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		gap: 10,
		paddingVertical: space.md,
		paddingHorizontal: 14,
		borderRadius: radius.card,
	},
	body: {
		flex: 1,
	},
	text: {
		...type.secondaryStrong,
		color: colors.text,
	},
	textWarning: {
		color: colors.warning,
	},
});

export default StepNote;
